<template>
	<li class="clearfloat">
		<div class="left">
			<h2>{{itemData.year || ''}}</h2>
			<h3>{{itemData.mounth || ''}}</h3>
		</div>
		<div class="right">
			<h3 class="title">
				<router-link class="title" :to="{ name: 'newsDetail', query: { id: itemData.id, status:itemData.trainingStatus || '' }}">{{itemData.title}}</router-link>
			</h3>
			<div>{{itemData.subTitle}}</div>
			<!-- <p v-html="itemData.content">
				{{itemData.content}}
			</p> -->
		</div>
	</li>
</template>

<script>
/**
 * 描述
 * @description 描述
 * @property {String}
 * @example <aby-botton-line  />
 */

export default {
	props: {
		itemData:[Object]
	},
	data() {
		return {};
	},
	computed: {},
	mounted(){
		
	},
	created(obj) {
		// 页面第一次加载执行，参数为上个页面传递的数据，参数类型为Object
		this.itemData.year = this.itemData.createTime.slice(0,4);
		this.itemData.mounth = this.itemData.createTime.slice(5,10)
	},
	methods: {},
	watch: {
		itemData: {
			//监听的对象
			deep: true, //深度监听设置为 true
			handler: function(newV, oldV) {
					this.itemData.year = newV.createTime.slice(0,4);
					this.itemData.mounth = newV.createTime.slice(5,10)
			}
		}
	}
};
</script>

<style scoped>
.title{
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
	}
</style>
